import { apiFetch } from "./apiFetch";

export interface UsageRecord {
	id: string;
	requestId: string;
	apiKeyId: string;
	modelConfigId: string;
	modelConfigName: string;
	cacheHit: boolean;
	cacheLayer: string | null;
	tokensInput: number;
	tokensOutput: number;
	tokensTotal: number;
	tokensWithoutCache: number;
	tokensSaved: number;
	responseTimeMs: number | null;
	costWithoutCache: number | null;
	actualCost: number | null;
	costSaved: number | null;
	status: string;
	errorMessage: string | null;
	errorCode: string | null;
	createdAt: string;
}

export interface LogsListResponse {
	logs: UsageRecord[];
	total: number;
	page: number;
	limit: number;
	totalPages: number;
}

export interface GetLogsParams {
	page?: number;
	limit?: number;
	status?: string;
	modelConfigId?: string;
	cacheHit?: boolean;
	cacheLayer?: string;
	from?: string;
	to?: string;
	search?: string;
}

export const logsService = {
	getLogs: async (
		projectId: string,
		params: GetLogsParams = {},
	): Promise<LogsListResponse> => {
		const queryParams = new URLSearchParams();
		if (params.page) queryParams.append("page", params.page.toString());
		if (params.limit) queryParams.append("limit", params.limit.toString());
		if (params.status) queryParams.append("status", params.status);
		if (params.modelConfigId)
			queryParams.append("modelConfigId", params.modelConfigId);
		if (params.cacheHit !== undefined)
			queryParams.append("cacheHit", params.cacheHit.toString());
		if (params.cacheLayer) queryParams.append("cacheLayer", params.cacheLayer);
		if (params.from) queryParams.append("from", params.from);
		if (params.to) queryParams.append("to", params.to);
		if (params.search) queryParams.append("search", params.search);

		const queryString = queryParams.toString();
		return apiFetch<LogsListResponse>(
			`/projects/${projectId}/logs${queryString ? `?${queryString}` : ""}`,
		);
	},

	getLogById: async (
		projectId: string,
		requestId: string,
	): Promise<UsageRecord> => {
		return apiFetch<UsageRecord>(`/projects/${projectId}/logs/${requestId}`);
	},
};
